import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { LoggerModule, PinoLogger } from 'nestjs-pino';
import wmsConfigs from '../../config';
import { QueryLogger } from '../../../logger/query-logger';
import { StockIn } from './stock-in/stock-in.entity';
import { StockInModule } from './stock-in/stock-in.module';
import {appSettings} from '../../../config';
import { StockModule } from './stock/stock.module';
import { Stock } from './stock/stock.entity';
import { ForkLiftJobsModule } from './fork-lift-jobs/fork-lift-jobs.module';
import { ForkLiftJobs } from './fork-lift-jobs/fork-lift-jobs.entity';
import { ForkLiftItemsModule } from './fork-lift-items/fork-lift-items.module';
import { ForkLiftItems } from './fork-lift-items/fork-lift-items.entity';
import { NotificationsModule } from './notifications/notifications.module';
import { Notifications } from './notifications/notifications.entity';
import { StockLog } from './stock/stock-log.entity';
import { StockView } from './stock/stock-view.entity';
import { WarehouseView } from './stock/warehouse-view.entity';
import { FgStockTransferModule } from './fg-stock-transfer/fg-stock-transfer.module';
import { fgStockTransfer } from './fg-stock-transfer/fg-stock-transfer.entity';
import { TemperatureLogModule } from './temperature-log/temperature-log.module';
import { TemperatureLog } from './temperature-log/entity/temperature-log.entity';
import { ScheduleModule } from '@nestjs/schedule';
import { FgDamagesModule } from './fg-damages/fg-damages-module';
import { fgDamagesEntity } from './fg-damages/dto/fg-damages-entity';
import { AllocatedSoEntity } from './stock/allocated-sale-order.entity';
@Module({
    // LoggerModule.forRoot({ pinoHttp: { level: wmsConfigs.loggingMode } }),
      imports: [
        TypeOrmModule.forRoot({
          type: 'mysql',
         host: appSettings.dbhost,
          port: 3306,
          username: appSettings.dbuser,
          password: appSettings.dbpassword,
          database: appSettings.warehouse_db,
      entities: [fgDamagesEntity, StockIn, Stock,ForkLiftJobs,ForkLiftItems,Notifications,StockView,StockLog,WarehouseView, fgStockTransfer,TemperatureLog,AllocatedSoEntity
      ],
      synchronize: false,
      extra:{
        connectionLimit: 20,
      },
      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: wmsConfigs.loggingMode } })),
  }),
  ScheduleModule.forRoot(),
    StockInModule,
    StockModule,
    ForkLiftJobsModule,
    ForkLiftItemsModule,
    NotificationsModule,
    FgStockTransferModule,
    TemperatureLogModule,
    FgDamagesModule
  ],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule {}
